import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.08 11.03L12.96 8.91L7 14.86V17H9.1L15.08 11.03Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.85 9.27C17.05 9.07 17.05 8.76 16.85 8.56L15.44 7.15C15.24 6.95 14.93 6.95 14.73 7.15L13.67 8.21L15.79 10.33L16.85 9.27Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "3.5",
  y: "3.5",
  width: "17",
  height: "17",
  rx: "0.5",
  stroke: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14 3C14 1.89543 13.1046 1 12 1C10.8954 1 10 1.89543 10 3",
  stroke: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }